import { createAsyncThunk } from '@reduxjs/toolkit';
import { Connection } from '../../../../model/types/positionsConnectionsSliceSchema';
import { RootState } from '../../../../../../store';
import { positionsConnectionsActions } from '../positionsConnectionsSlice';

const isNotRemovedConnection = (
    positionConnection: Connection,
    removedConnection: Connection
): boolean =>
    !(
        positionConnection.from === removedConnection.from &&
        positionConnection.to === removedConnection.to &&
        positionConnection.type === removedConnection.type
    );
export const removeManyConnections = createAsyncThunk<void, Connection[], { state: RootState }>(
    'positionsConnections/removeManyConnections',
    async (removedConnections, { getState, dispatch }) => {
        const state = getState();

        const { connections: positionsConnections } = state.positionsConnectionsReducer;

        const updatedConnections = positionsConnections.filter(
            (connection) =>
                !removedConnections.some(
                    (r) =>
                        connection.from === r.from &&
                        connection.to === r.to &&
                        connection.type === r.type
                )
        );

        dispatch(positionsConnectionsActions.setConnections(updatedConnections));
    }
);
